// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2lfIl","title":"Images45_title__31xl7","images":"Images45_images__Ko4y8"};